export default {
  resources: {
    list: "List",
    customers: {
      title: "Customers",
      fieldList: {
        name: "Name",
        email: "Email",
        create_at: "Create On",
        first_name: "First Name",
        last_name: "Last Name",
        google_email: "Google Email",
        mobile: "Mobile",
        address: "Address",
        province: "Province",
        city: "City",
        district: "District",
        postCode: "Post Code",
      },
    },
    accounts: {
      title: "Accounts",
      fieldList: {
        name: "Name",
        create_at: "Create On",
        type: {
          title: "Type",
          choices: {
            brand: "Brand",
            merchant: "Merchant",
            supplier: "Supplier",
            agency: "Agency",
          },
        },
        users: "Users",
        campaigns: "Campaigns",
      },
    },
    admin: {
      title: "Admin",
    },
    users: {
      title: "Users",
      fieldList: {
        name: "Name",
        email: "Email",
        role: {
          title: "Role",
          choices: {
            partner_admin: "Partner Admin",
            partner_user: "Partner User",
            recruiter: "Recruiter",
          },
        },
        create_at: "Create On",
        first_name: "First Name",
        last_name: "Last Name",
        google_email: "Google Email",
        mobile: "Mobile",
      },
    },
    campaigns: {
      title: "Campaigns",
      titleUsers: "KOL",
      titleCollections: "Collection Product",
      titleChart: "Statistic KOL",
      fieldList: {
        name: "Name",
        status: {
          title: "Status",
          choices: {
            active: "Active",
            suspended: "Suspended",
            cancelled: "Cancelled",
            completed: "Completed",
          },
        },
        start_date: "Start Date",
        end_date: "End Date",
        microsites: "Microsites",
        youtube_url: "Youtube Id",
        media_url: "Media Url",
        categories: "Categories",
      },
    },
    categories: {
      title: "Categories",
      fieldList: {
        name: "Name",
        create_at: "Create On",
        property: "Properties",
      },
    },
    collections: {
      title: "Collections",
      titleNew: "New Collections",
      titleEdit: "Edit Collections",
      fieldList: {
        name: "Name",
        create_at: "Create On",
        description: "Description",
        banners: {
          desktop: "Banner Desktop",
          mobile: "Banner Mobile",
        },
      },
    },
    pages: {
      title: "Pages",
      titleNew: "New Page",
      titleEdit: "Edit Page",
      fieldList: {
        name: "Name",
        marketer: "Marketer",
        create_at: "Create On",
        tracking: "Tracking",
        collections: "Collections",
        slug: "Slug",
        active: "Active",
        description: "Description",
        banners: {
          desktop: "Banner Desktop",
          mobile: "Banner Mobile",
        },
      },
    },
    products: {
      title: "Products",
      titleNew: "New Products",
      titleEdit: "Edit Products",
      actions: {
        search: "Search",
        addVariant: "Add Variants",
      },
      errorMessage: {
        slugHave: "The Slug already have",
      },
      titleField: {
        variants: "Variants",
        payments: "Payment Settings",
        properties: "Properties",
      },
      fieldList: {
        account: "Account",
        name: "Name",
        create_at: "Create On",
        slug: "Slug",
        category: "Category",
        active: "Active",
        status: "Status",
        brand: "Brand",
        tags: "Tags",
        collections: "Collections",
        contents: "Contents",
        price: "Price",
        discount: "Discount",
        margin: "Margin (Rp)",
        sortOrder: "Sort Order",
        description: "Description",
        photos: "Photos",
        variant: "Variant",
        tracking: "Tracking",
        partner_margin: "Partner Margin (Rp)",
        properties: {
          screenSize: "Screen size",
          cpu: "CPU",
          resolution: "Resolution",
        },
        payment: {
          installment: "Installment",
          paymentmode: "Payment Mode",
          bin: "Bin",
          cc_settings: "Creadit Card Payment Settings",
          enabled_payments: "Support Payment Mode",
        },
        shipping: {
          free_shipping: "Free shipping",
          weight: "Weight (kg)",
          subsidy: "Subsidy",
        },
        helpText: {
          discount: "0.1 for 10% discount or 20000 for amount",
        },
        variantField: {
          name: "Name",
          sku: "SKU",
          price: "Price",
          quantity: "Quantity",
          active: "Active",
        },
        productType: {
          title: "Product Type",
          titlePlanType: "Plan Type",
          choices: {
            product: "Product",
            ticket: "Ticket",
            voucher: "Voucher",
            indosatMsp: "Indosat MSP",
            corporateCampaign: "Corporate Campaign",
          },
        },
        event: {
          title: "Event",
          date: "Event Date",
          time: "Event Time",
        },
        term: "Term & Conditions",
      },
    },
    marketers: {
      title: "Marketers",
      account: "Accounts",
      categories: "Content category",
      fields: {
        title: "Details",
        first_name: "First Name",
        last_name: "Last Name",
        nickname: "Nickname",
        status: "Status",
        email: "Email",
        create_at: "Create On",
        google_email: "Google Email",
        mobile: "Mobile",
        avatar: "Avatar",
        profile: "Profile",
        partner_id: "Partner Code",
      },
      banks: {
        title: "Bank",
        bank: "Bank",
        bank_account: "Bank Account",
        full_name: "Full Name",
        bank_branch: "Bank Branch",
      },
      social: {
        title: "Social Media",
        instagram: "instagram",
        titleinstagram: "Instagram",
        facebook: "facebook",
        titlefacebook: "Facebook",
        twitter: "twitter",
        titletwitter: "Twitter",
        youtube: "youtube",
        titleyoutube: "Youtube",
        followers: "Followers",
      },
      sales: {
        product: "Product",
        amount: "Amount",
        create_at: "Create On",
        ref: "Order #Ref",
        status: "Status",
      },
      transactions: {
        transaction: "Transaction",
        amount: "Amount",
        reference: "Reference #",
        create_at: "Create On",
      },
      transfers: {
        title: "Transfers",
        subheader: "Details",
        fields: {
          first_name: "First Name",
          last_name: "Last Name",
          status: "Status",
          amount: "Amount",
          email: "Email",
          create_at: "Created",
          google_email: "Google Email",
          mobile: "Mobile",
          bank: "Bank",
          marketer: "Marketer",
          transaction: "Transaction #",
          date: "Date",
          bank_account: "Bank Account",
          balance: "Balance",
        },
        actions: {
          save: "Save",
          close: "Close",
          adjust_commission: "Adjust Commission",
        },
      },
    },
    orders: {
      title: "Orders",
      fieldList: {
        order: "Orders",
        customer: "Customer",
        marketer: "Marketer",
        account: "Account",
        channel: "Channel",
        status: "Status",
        total: "Total",
        created_at: "Created",
        note: "Note",
        updated_at: "Last",
        assignedTo: "Assigned To",
        emailInvoice: "Email invoice to customer",
        tracking: "Tracking",
      },
      actions: {
        search: "Search",
        selectCustomer: "Select Customer",
      },
    },
    reports: {
      name: "Reports",
      sales: {
        name: "Sales Report",
      },
      inventory: {
        name: "Inventory Report",
      },
      buttonSave: "Generate",
    },
    static: {
      title: "Statics",
    },
    email: {
      title: "Email",
      field: {
        name: "Name",
      },
    },
    contents: {
      title: "Contents",
      titleChart: "Chart View",
      field: {
        title: "Title",
        marketer: "Marketer",
        slug: "Slug",
        active: "Active",
        collections: "Collections",
      },
    },
    editor: {
      title: "Editor",
      field: {
        title: "Title",
        slug: "Slug",
        active: "Active",
      },
    },
    vouchers: {
      title: "Vouchers",
      field: {
        title: "Vouchers",
        campaign: "Campaign",
        start_date: "Start Date",
        end_date: "End Date",
        count: "Count",
        unlimited: "Unlimited",
        campaignName: "Campaign Name",
        customer_segment: "Customer Segment",
        products: "Products",
      },
    },
    reloads: {
      title: "Reloads",
      uploadFile: "Upload File",
      selectFile: "Select File",
      next: "Next",
      summary: "Summary",
      failedUpload: "Failed Upload",
      failedReload: "Failed Reload",
      execute: "Execute",
      downloadReport: "Download Report",
      field: {
        date: "Date",
        batchNumber: "Batch #",
        totalNumbers: "Total Numbers",
        totalValues: "Total Values",
        transactionId: "Transaction ID",
        bankReference: "Bank Reference",
        phoneNumber: "Phone Number",
        value: "Value",
        status: "Status",
        message: "Message",
        gemilangReference: "Gemilang Reference",
        lineNumber: "Line #",
        content: "Content",
        reason: "Reason",
        totalProcessed: "Total Processed",
      },
    },
    tickets: {
      title: "Tickets",
      field: {
        name: "Name",
        total_tickets: "Total ticket",
        valid: "Valid",
        invalid: "Invalid",
      },
    },
    payments: {
      title: "Payment",
      titleHeader: "Payment Settings",
      titleNew: "New Payment Settings",
      titleEdit: "Edit Payment Settings",
      field: {
        name: "Name",
        bankName: "Bank Name",
        type: "Type",
        active: "Active",
        logo: "Logo (120x120)",
        terms: {
          title: "Terms",
          term: "Term",
          interest: "Interest %",
          fee: "Fee %",
        },
      },
    },
    paymentmode: {
      title: "Payment Mode",
      titleHeader: "Payment Mode",
      titleNew: "New Payment Mode",
      titleEdit: "Edit Payment Mode",
      field: {
        name: "Name",
        active: "Active",
        supportedMethods: "Supported Methods",
        supportBins: "Supported Bins",
        installment: "Installment",
        errorMessage: "Error Message",
      },
    },
    sim: {
      titleIndosat: "Indosat",
      title: "Sim Cards",
      titleNew: "New",
      titleEdit: "Edit",
      field: {
        date: "Date",
        total: "Total",
        sold: "Sold",
        msisdn: "MSISDN",
        simcard: "Sim Card #",
        type: "Type",
        expiryDate: "Expiry Date",
        status: "Status",
        importCSV: "Import CSV",
      },
      actions: {
        updated: "Sim updated success",
        warning: "Please try again",
      },
    },
    activation: {
      title: "Activations",
      field: {
        from: "From",
        to: "To",
        date: "Date",
        name: "Name",
        order: "Order",
        email: "Email",
        msisdn: "MSISDN",
        status: "Status",
        motherName: "Mother's name",
        gender: "Gender",
        address: "Address",
        simcard: "Sim #",
        planType: "Plan Type",
        planID: "Plan ID",
        period: "Period",
        ktp: "KTP",
      },
    },
    agency: {
      title: "Agency",
      titleChart: "Commissions",
      newTitle: "New Agency",
      editTitle: "Edit Agency",
      marketerTitle: "Marketers",
      newMarketerTitle: "New Marketer",
      editMarketerTitle: "Edit Marketer",
      importTitle: "Import",
      field: {
        name: "Name",
        first_name: "First name",
        last_name: "Last name",
        google_email: "Google mail",
        email: "Email",
        margin: "Margin %",
        mobile: "Mobile",
        create_at: "Created On",
        users: "Users",
        contact: "Main Contact Person",
        total: "Total KOL",
        api_key: "Api key",
        social: {
          instagram: "Instagram",
          youtube: "Youtube",
        },
      },
    },
    corporate_campaign: {
      title: "Corporate Campaign",
      title_menu: "Corporate",
      title_submenu: "Campaigns",
      field: {
        name: "Name",
        email_whitelists: "Email Whitelist",
        active: "Active",
        start_date: "Start Date",
        end_date: "End Date",
      },
    },
    actions: {
      search: "Search",
      error: {
        try: "Please try again",
        emailSent: "Email sent",
      },
    },
  },
  Conflict: "Conflict: this product can not delete",
};



// WEBPACK FOOTER //
// ./src/i18n/en.js